module.exports = __webpack_public_path__ + "assets/img/nav-item-2-5205dd91.png";